import PopupMenuRow from '@osmosis/nextjs-components/PopupMenu/PopupMenuRow';
export * from '@osmosis/nextjs-components/PopupMenu/PopupMenuRow';
export default PopupMenuRow;
